import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export default function LoginSuccess() {
  const history = useHistory();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    console.log('[LoginSuccess] token from URL:', token ? token.substring(0, 20) + '...' : 'none');

    if (token) {
      try {
        // Decode JWT payload (base64) to check expiry
        const payload = JSON.parse(atob(token.split('.')[1]));
        console.log('[LoginSuccess] JWT payload:', { sub: payload.sub, email: payload.email, exp: payload.exp });
        if (payload.exp > Date.now() / 1000) {
          localStorage.setItem('distill_auth_token', token);
          console.log('[LoginSuccess] Token stored — user authenticated');
        } else {
          console.warn('[LoginSuccess] Token already expired — not storing');
        }
      } catch (e) {
        console.error('[LoginSuccess] Failed to parse token:', e);
      }
    }

    history.replace('/distill-v2');
  }, [history]);

  return (
    <div style={{ padding: 60, textAlign: 'center', fontFamily: 'sans-serif', color: '#555' }}>
      Signing you in…
    </div>
  );
}
